import React from 'react';

const TermsOfUse = () => {
    return (
        <div className="max-w-4xl mx-auto mt-24 py-10 px-4 text-gray-800">
            <h1 className="text-3xl font-semibold text-black mb-4">Terms of Use</h1>
            <p className="text-sm text-gray-500">Last Updated: 11 November 2024</p>

            <section className="mt-6 space-y-4">
                <p className="leading-relaxed">
                    Welcome to XReality Education Limited. By accessing and using our platform, you agree to comply with our
                    Terms of Fair Use. These terms are designed to promote a fair, safe, and constructive learning environment
                    for all users. Failure to follow these guidelines may result in the restriction or termination of your
                    access to our platform.
                </p>
            </section>

            <div className="border-b border-gray-200 my-6"></div>

            <h2 className="text-xl font-bold text-black mt-8">1. Acceptable Use</h2>
            <p className='my-2'>XReality Education provides Augmented Reality (AR) and Virtual Reality (VR) learning experiences and online educational resources for students, educators, and parents. Users are expected to:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Respect Intellectual Property:</strong> All course materials, AR/VR content, videos, quizzes, and other resources are the intellectual property of XReality Education. Users may not reproduce, distribute, or create derivative works based on this content without express written permission.</li>
                <li>- <strong>Use Content for Educational Purposes:</strong> Content and resources provided on our platform are intended for personal, educational use only.</li>
                <li>- <strong>Follow Age and Consent Requirements:</strong> Users under 18 must have parental consent to access the platform, and parents/guardians are responsible for supervising their minor’s usage.</li>
            </ul>

            <h2 className="text-xl font-bold text-black mt-8">2. Prohibited Use</h2>
            <p className='my-2'>Users may not engage in any of the following activities:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Copying or Redistribution of Content:</strong> Unauthorized copying, sharing, or redistribution of course materials, lessons, videos, or other proprietary content is strictly prohibited.</li>
                <li>- <strong>Commercial Use:</strong> Using XReality Education’s materials for commercial purposes, including reselling or unauthorized tutoring, is not allowed.</li>
                <li>- <strong>Plagiarism:</strong> Users must complete assignments and tests on their own without copying from other sources, platforms, or users.</li>
                <li>- <strong>Data Mining or Extraction:</strong> Users may not employ bots, data miners, or similar tools to extract or collect data from our platform.</li>
                <li>- <strong>Disruptive or Harmful Behavior:</strong> Any attempt to disrupt the platform’s services or introduce malicious software, viruses, or other harmful code is strictly prohibited.</li>
                <li>- <strong>Hate Speech and Discrimination:</strong> Hate speech, bullying, or any form of discrimination based on race, ethnicity, religion, gender, disability, or sexual orientation is strictly forbidden on XReality Education. Any form of hateful behavior will lead to immediate action, including account suspension or termination.</li>
                <li>- <strong>Religious Extremism and Radicalization:</strong> Content promoting or supporting religious extremism, radicalization, or any form of incitement to violence is strictly prohibited. Users found engaging in such activities will be banned from the platform.</li>
                <li>- <strong>Harassment or Stalking of Other Users:</strong> Users may not stalk, harass, or intimidate others on the platform, including sending repeated unwanted messages or making others feel unsafe.</li>
            </ul>

            <h2 className="text-xl font-bold text-black mt-8">3. Intellectual Property Rights</h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                All content on the XReality Education platform, including text, images, logos, AR/VR experiences, and
                software, is protected by Canadian intellectual property laws.
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Ownership:</strong>XReality Education retains all rights, titles, and interests in its content, including proprietary AR/VR software, curriculum materials, quizzes, and lessons.
                </li>
                <li>- <strong>Limited License:</strong>Users are granted a limited, non-exclusive, non-transferable license to use the platform’s content for personal, educational purposes only.
                </li>
            </ul>



            <h2 className="text-xl font-bold text-black mt-8">    4. User-Generated Content
            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                XReality Education allows users to participate in discussions, forums, and project submissions. By submitting content, users agree to the following:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Content Ownership:</strong>Users retain ownership of their content but grant XReality Education a non-exclusive, royalty-free license to use, display, and reproduce submitted content for educational purposes.

                </li>
                <li>- <strong>Responsibility:</strong>Users are responsible for ensuring that their content is accurate, lawful, and does not violate third-party rights or privacy laws.

                </li>
                <li>- <strong>Prohibited Content:</strong>Users may not upload or share any content that is offensive, discriminatory, harassing, harmful, extremism, or any form of bullying.

                </li>
            </ul>



            <h2 className="text-xl font-bold text-black mt-8">5. Privacy and Personal Data Use
            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                XReality Education respects user privacy and follows Canadian privacy laws, including the **Personal Information Protection and Electronic Documents Act (PIPEDA)**. By using our platform, users consent to our collection, use, and storage of personal information as outlined in our **Privacy Policy**. Users under 18 must obtain parental consent.



            </p>
            <h2 className="text-xl font-bold text-black mt-8">    6. Limitations of Liability

            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                XReality Education is committed to providing a safe and effective learning platform. However, we disclaim liability for:



            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Third-Party Content:</strong>Any content provided by third-party partners or advertisers does not represent the views or endorsement of XReality Education.


                </li>
                <li>- <strong>Platform Downtime or Errors:</strong>XReality Education is not liable for technical issues, errors, or downtime that may affect access to the platform.

                </li>
                <li>- <strong>Learning Outcomes:</strong>While we strive to provide high-quality content, XReality Education does not guarantee specific learning outcomes or improvements.

                </li>
            </ul>



            <h2 className="text-xl font-bold text-black mt-8">7. Violation of Terms and Termination

            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
            XReality Education reserves the right to suspend or terminate user accounts for any violations of these Terms of Fair Use, including but not limited to:




            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li> Unauthorized use, redistribution, or resale of content


                </li>
                <li> Violation of intellectual property rights.

                </li>
                <li> Any prohibited behavior, including hate speech, extremism, harassment, or stalking, that disrupts the safe, respectful environment of the platform.

                </li>
                <li>Upon termination, users must cease all use of XReality Education’s content and services and delete any downloaded content that violates these terms.
                </li>
            </ul>


            <h2 className="text-xl font-bold text-black mt-8">8. Amendments to Terms


            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
            XReality Education reserves the right to modify or update these Terms of Fair Use at any time. Users will be notified of significant changes, and continued use of the platform after any modifications constitutes acceptance of the revised terms.




            </p>
            <h2 className="text-xl font-bold text-black mt-8">9. Reporting Prohibited Activities


            </h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
            XReality Education is committed to maintaining a safe, respectful, and positive learning environment for all users. Therefore, we reserve the right to monitor content and user activity on our platform. If we detect any of the following activities, we reserve the right to report them to relevant law enforcement authorities:



            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Extremism and Radicalization: </strong>Promotion or support of extremism, radicalization, incitement to violence, or content that promotes hate speech, self harm or terrorist activities.


                </li>
                <li>- <strong>Bullying or Harassment of Minors:</strong>Any form of bullying, harassment, or intimidation directed at minors, including stalking, repeated unwanted contact, or any behavior that could harm the physical or emotional well-being of a minor.


                </li>
                <li>- <strong>Pornography or Inappropriate Content:</strong>Sharing, uploading, or distributing pornographic content or any content inappropriate for minors, including explicit material, sexually explicit behavior, or exploitative content.

                </li>
                <p className="mt-4 text-gray-700 leading-relaxed">
                Users found engaging in these prohibited activities will face immediate termination of their accounts, and relevant details will be shared with law enforcement to ensure the safety and protection of our community.


            </p>
            </ul>







            <h2 className="text-xl font-bold text-black mt-8">10. Contact Information</h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                If you have any questions regarding these Terms of Fair Use or if you need further clarification, please
                contact us:
            </p>
            <p className="text-gray-700">
                <strong>XReality Education</strong><br />
                Email: <a href="mailto:info@xrealityedu.com" className="text-primary hover:underline">info@xrealityedu.com</a>
            </p>

            <p className="mt-8 text-gray-600">
                By using XReality Education, you agree to follow these Terms of Fair Use, ensuring that the platform
                remains a valuable, fair, and respectful resource for all. Thank you for contributing to a positive
                learning environment!
            </p>
        </div>
    );
};

export default TermsOfUse;